export default __webpack_public_path__ + "static/Fellix-Black-76091a7c3d5fb5e8782a7219d81d4e6d.otf";